import React, { useMemo } from 'react';
import { Text3D } from '@react-three/drei';
import { TEXT_3D_CONFIG, COLORS } from '../../constants';

const SHADOW_MATERIAL = { color: '#000000', opacity: 0.6, transparent: true };
const MAIN_MATERIAL = {
  metalness: 0.9,
  roughness: 0.5,
  color: COLORS.PRIMARY,
  emissive: '#003344',
  emissiveIntensity: 0.2,
};
const SUBTITLE_MATERIAL = {
  metalness: 0.9,
  roughness: 0.5,
  color: COLORS.SUBTITLE,
  emissive: '#002233',
  emissiveIntensity: 0.15,
};

export default function Text3DComponent({ 
  text, 
  variant = 'main', 
  materialProps = {}, 
  position,
  isShadow = false,
  ...otherProps 
}) {
  const config = useMemo(
    () => variant === 'main' ? TEXT_3D_CONFIG.MAIN_TITLE : TEXT_3D_CONFIG.SUBTITLE,
    [variant]
  );
  
  const defaultMaterial = useMemo(() => {
    if (isShadow) return SHADOW_MATERIAL;
    return variant === 'main' ? MAIN_MATERIAL : SUBTITLE_MATERIAL;
  }, [isShadow, variant]);

  return (
    <Text3D
      font={TEXT_3D_CONFIG.FONT_PATH}
      size={config.SIZE}
      height={config.HEIGHT}
      bevelEnabled
      bevelThickness={config.BEVEL_THICKNESS}
      bevelSize={config.BEVEL_SIZE}
      bevelSegments={config.BEVEL_SEGMENTS}
      curveSegments={config.CURVE_SEGMENTS}
      position={position || config.POSITION}
      {...otherProps}
    >
      {text}
      <meshStandardMaterial {...defaultMaterial} {...materialProps} />
    </Text3D>
  );
}

